<template>
    <div class="borrowDetailsBox">
        <Box title="设备调配归还申请">
            <div class="equipment box">
                <p class="title">设备信息</p>
                <div class="equipment-details">
                    <img src="@/assets/img/Icon_1.png" />
                    <div>
                        <div>
                            <p>资产名称：</p>
                            <p>资产编号：</p>
                            <p>规格型号：</p>
                            <p class="ellipsis">资产序列号：</p>
                        </div>
                        <div>
                            <p class="ellipsis">{{equipment.SBMC}}</p>
                            <p class="ellipsis">{{equipment.SBBH}}</p>
                            <p class="ellipsis">{{equipment.SBXH}}</p>
                            <p class="ellipsis">{{equipment.SBXLH}}</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="ellipsis">管理科室： {{equipment.GLKS}}</div>
                    <div class="ellipsis">注册证件号： {{equipment.ZCZJH}}</div>
                </div>
            </div>

            <div class="accessories box">
                <p class="title">配件信息</p>
                <div style="color: #666666;" v-if="accessories.length===0">暂无</div>
                <div>
                    <div>
                        <van-checkbox-group v-model="result">
                            <div class="check-box" v-for="(item, index) in accessories" ref="checkboxGroup">
                                <van-checkbox :name="index" checked-color="#4fa69e">{{item.PJMC}}</van-checkbox>
                                <span>{{item.BZ}}</span>
                            </div>
                        </van-checkbox-group>
                    </div>
                </div>
            </div>

            <div class="borrow box">
                <p class="title">调配信息</p>
                <Field title="申请单号" :text="equipment.DH" type="text"/>
                <Field title="申请人" :text="equipment.SQRMC" type="text"/>
                <Field title="申请科室" :text="equipment.SQKSMC" type="text"/>
                <Field title="借用申请日期" :text="$format(equipment.SQRQ,'YYYY-MM-DD')" type="text"/>
                <Field title='实际借用日期' type='text' :text="$format(borrow.PracticalBorrowDate,'YYYY-MM-DD HH:mm:ss')" />
                <Field title="归还申请日期" :text="$format(date,'YYYY-MM-DD HH:mm:ss')" type="text"/>
                <Field title="联系方式" :text="equipment.LXFS" type="text" />
                <Field title='借用单价' :action='true' type='text' :text='`${borrow.JFBZ||0}元`' />
                <Field title='当前借用时长' :action='true' type='text' :text='`${borrow.Duration}小时`' />
                <Field title='当前借用金额' :action='true' type='text' :text='`${Number(borrow.JFBZ*borrow.Duration).toFixed(2)}元`' />
                <Field title='实际借用金额(优惠后)' :action='true' type='text' :text='`${borrow.Unit}元`' />
                <Field title='申请说明' type='textarea' :text='BZ' @onMessage='e=>BZ=e'/>
                <van-cell>
                    <template>
                        <div class="borrowHelper" @click="show=true">
                             <span>帮助</span>
                             <img src="@/assets/img/Helper.png" />
                        </div>
                    </template>
                </van-cell>
            </div>

            <van-popup v-model="show" position="bottom" round :style="{width:'100%'}">
                <div>
                    <div>
                        <div class="FYBZTitle">
                            <span>当前计费形式:</span><span>{{FYBZMC}}</span>
                            <p>借用金额最终以归还申请的审核时间为截点来计算</p>
                        </div>
                        <van-cell title="正常计费" />
                        <van-cell>
                            <template>
                                <div class="JFBZ">
                                    借用金额=计费单价*计费时长
                                </div>
                            </template>
                        </van-cell>
                        <van-cell title="24小时计费" />
                        <van-cell>
                            <template>
                                <div class="JFBZ">
                                    借用金额=24小时计费单价*计费时长/24
                                </div>
                                <div class="JFBZ">
                                    例:(计费单价3元/小时;65元/天;计费时长240小时;<br/>借用金额=65*240/24)
                                </div>
                            </template>
                        </van-cell>
                        <van-cell title="递进计费"/>
                        <van-cell>
                            <template>
                                <div class="JFBZ">
                                    借用金额=第一阶梯内时长*计费单价*阶梯内折扣+第二阶梯内时长*计费单价*阶梯内折扣+(n...)
                                </div>
                                <div class="JFBZ">
                                    未达到递进标准:借用金额=计费单价*计费时长
                                </div>
                            </template>
                        </van-cell>
                    </div>
                </div>
            </van-popup>

        </Box>
        <div class="footer">
            <div class="button" @click="upload">提交申请</div>
        </div>
    </div>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import {
        Popup,
        Cell,
        Checkbox,
        CheckboxGroup,
        ImagePreview
    } from 'vant'
    import Field from '@/components/field/field'
    export default {
        name: 'DeployGiveDefault',
        data() {
            return {
                date:new Date(),
                borrow:{},//费用及时长情况
                show:false,
                //    设备信息
                equipment: {},
                //    配件信息
                accessories: [],
                //    选中的配件信息
                result: [], //
                BZ: '',//    申请说明
                FYBZMC:null,
            }
        },
        components: {
            Box,
            Field,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [Cell.name]:Cell,
            [Popup.name]:Popup
        },
        mounted() {
            let _this = this;
            this.timer = setInterval(() => {
                  _this.date = new Date(); // 修改数据date
                }, 1000)
            this.equipment = this.$route.query.Equipment;
            this.loadDeployPJ();
        },
        methods: {
            loadDeployPJ() {
                var that=this;
                that.$axios.all([that.$get('api/DeployEquipment/GetDeployAuditPJInfo',{
                    DH: this.equipment.DH,
                    JYLB: 'Y'
                }),that.$get('api/DeployEquipment/GetBorwerCost',{
                     SQDH:this.equipment.DH
                })]).then(that.$axios.spread(function(result1,result2){
                    that.accessories=result1;
                    that.result=result1.map((item,index)=>{
                        return index;
                    })
                    try{
                        that.borrow=JSON.parse(result2);
                        that.FYBZMC=that.borrow.FYBZ==='Y'?'正常计费':that.borrow.FYBZ==='N'?'24小时计费':'递进计费';
                    }catch(e){
                        that.$Toast('数据异常,请联系管理员!');
                    }
                }));
            },
            upload() { //提交归还申请 //进行配件配置
                const PJDefault = [];
                for (let i = 0; i < this.accessories.length; i++) {
                    let num = {
                        Code: this.accessories[i].Code,
                        REMARK: '',
                        SYZT: this.result.findIndex(x => x === i) != -1 && this.accessories[i].SYZT === 'Y' ? 'Y' :
                            'N'
                    };
                    PJDefault.push(num);
                }
                var DeployModel = {
                    SBBH: this.equipment.SBBH,
                    SBMC: this.equipment.SBMC,
                    DH: this.equipment.DH,
                    SQR: this.$UserInfo.UserId,
                    SQKS: this.equipment.SQKS,
                    BZ: this.BZ
                };
                this.axiosUpdate(PJDefault, DeployModel);

            },
            axiosUpdate(PJDefault, DeployModel) { //api请求
                this.$post('api/DeployEquipment/UpdateDeployBack', {
                    PJArray: PJDefault,
                    EquipmentModel: DeployModel
                }).then(result => {
                    if (result.code === 10000) {
                        this.$Toast({
                            message:result.msg,
                            duration:1000,
                            onClose:()=>{
                                this.$router.back();
                            }
                        })
                    } else {
                        this.$Toast(result.msg);
                    }
                })
            }
        },beforeDestroy(){
            if (this.timer) {
               clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
            }
        }
    }
</script>

<style scoped lang="scss">
    .borrowDetailsBox {
        padding-bottom: 120px;
    }

    .box {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 34px 40px 0;
        box-sizing: border-box;
        margin-bottom: 20px;
    }

    .title {
        color: $TEXT-DARK-COLOR;
        font-size: 34px;
        font-weight: bold;
    }

    .equipment {
        height: 424px;

        img {
            width: 150px;
            height: 150px;
        }

        .equipment-details {
            display: flex;
            margin-top: 24px;

            &>div {
                margin-left: 34px;
                display: flex;

                div {
                    &:first-child {
                        color: #999;
                        line-height: 55px;
                    }

                    &:last-child {
                        color: #333;
                        line-height: 55px;

                        p {
                            width: 280px;
                            font-size: 29px;
                            color: #333;
                        }
                    }
                }
            }
        }

        &>div:last-child {
            display: flex;
            border-top: 2px solid #F3F3F3;
            margin-top: 20px;

            div {
                flex: 1;
                text-align: left;
                height: 66px;
                line-height: 66px;
                font-size: 29px;
                color: #999;

                &:first-child {
                    border-right: 2px solid #F3F3F3;
                }
            }
        }
    }

    .accessories {
        .title {
            margin-bottom: 10px;
        }

        .check-box {
            display: flex;
            height: 112px;
            border-bottom: 2px solid #F3F3F3;

            .van-checkbox {
                flex: 1;
            }

            span {
                margin-top: 30px;
            }
        }

        .check-box1 {
            .van-checkbox {
                width: 60px;
            }
        }

    }

    .explain {
        input {
            width: 100%;
            text-align: left;
            margin: 20px 0 48px;
        }
    }

    input {
        width: 150px;
        font-size: 29px;
        text-align: center;
        color: #858585;

        &::-webkit-input-placeholder {
            color: #858585;
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 114px;
        background: $BACKGROUND-COLOR;
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
        padding-top: 24px;

        .button {
            width: 690px;
            height: 96px;
            background: $THEME-COLOR;
            border-radius: 8px;
            color: $TEXT-LIGHT-COLOR;
            font-size: 30px;
            text-align: center;
            line-height: 96px;
            margin: auto;
        }
    }
    .borrowHelper{
        float: right;
        color: #666666;
        height: 50px;
        span{
           position: absolute;
           top: 0px;
           right: 38px;
           bottom: 0px;
        }
        img{
            width: 40px;
            height:40px;
        }
    }

    .JFBZ{
        color: #969799;
        text-align: left;
    }
    .FYBZTitle{
        background: #4FA69E;
        height: 70px;
        text-align: left;
        span{
            color: #FFFFFF;
            margin-left: 25px;
        }
        p{
            font-size: 12px;
            color:#FFFFFF;
            text-indent: 2em;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/DeployGiveDefault/DeployGiveDefault.vue